module.exports = __webpack_public_path__ + "static/media/banner2.0b221811.jpg";